import { AppContextProps } from '../../hooks/useApp'
import { AirAirHeatPumpAppliance } from './AirAirHeatPumpAppliance'
import { AirWaterHeatPumpAppliance } from './AirWaterHeatPumpAppliance'
import { Appliance, ApplianceConfig, ApplianceData, ApplianceType } from './Appliance'
import { BoilerAppliance } from './BoilerAppliance'
import { EvseAppliance } from './EvseAppliance'
import { GroundSourceHeatPumpAppliance } from './GroundSourceHeatPumpAppliance'
import { InFloorHeatingAppliance } from './InFloorHeatingAppliance'
import { SolarAppliance } from './SolarAppliance'
import { RadiatorAppliance } from './RadiatorAppliance'
import { StorageTankAppliance } from './StorageTankAppliance'
import { UnknownRelayAppliance } from './UnknownRelayAppliance'
import { EnergyMeterAppliance } from './EnergyMeterAppliance'
import { SystemControl } from '../SystemControl'
import { TemperatureAppliance } from './TemperatureAppliance'
import { BatteryAppliance } from './BatteryAppliance'
import { FCRBatteryAppliance } from './FCRBatteryAppliance'
import { HeatPumpAppliance } from './HeatPumpAppliance'

const ApplianceTypes: Record<ApplianceType, typeof Appliance<ApplianceConfig>> = {
  BATTERY: BatteryAppliance,
  EV_CHARGER: EvseAppliance,
  RADIATOR: RadiatorAppliance,
  AIR_AIR_HEAT_PUMP: AirAirHeatPumpAppliance,
  AIR_WATER_HEAT_PUMP: AirWaterHeatPumpAppliance,
  GROUND_SOURCE_HEAT_PUMP: GroundSourceHeatPumpAppliance,
  BOILER: BoilerAppliance,
  IN_FLOOR_HEATING: InFloorHeatingAppliance,
  STORAGE_TANK: StorageTankAppliance,
  SOLAR_PANEL: SolarAppliance,
  TEMPERATURE: TemperatureAppliance,
  ENERGY_METER: EnergyMeterAppliance,
  OTHER_RELAY: UnknownRelayAppliance,
  FCR_BATTERY: FCRBatteryAppliance,
  HEAT_PUMP: HeatPumpAppliance,
}

/**
 * Check that a string (e.g. a URL parameter) names a known appliance type.
 */
export function isApplianceType(type: string | undefined): type is ApplianceType {
  return !!type && Object.prototype.hasOwnProperty.call(ApplianceTypes, type)
}

/**
 * Instantiate an appliance for the given data.
 */
export function getAppliance(data: ApplianceData, control: SystemControl, app: AppContextProps) {
  if (!ApplianceTypes[data.type]) {
    throw new Error(`Invalid appliance type '${data.type}'.`)
  }
  return new ApplianceTypes[data.type](data, control, app)
}
